import('@shell/bootstrap');

export {};
